import React from 'react'

import update from 'immutability-helper'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import CategoriesPage from './Components/Categories/CategoriesPage'
import CompetitionHeader from './Components/CompetitionHeader'
import GalleryPage from './Components/Gallery/GalleryPage'
import ModalPreview from './Components/Gallery/ModalPreview'
import JudgesPage from './Components/Judges/JudgesPage'
import LandingPage from './Components/LandingPage'
import NavigationMenu from './Components/NavigationMenu'
import PartnersPage from './Components/Partners/PartnersPage'
import RulesPage from './Components/Rules/RulesPage'

class Competition extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      images: [],
      selectedImages: [],
      mainImageId: null,
      preloaders: [],
      galleryOrder: [],
      gallerySlugs: [],
    }

    this.onDrop = this.onDrop.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onUploadSuccess = this.onUploadSuccess.bind(this)
    this.onUploadFailure = this.onUploadFailure.bind(this)
    this.onRemoveImages = this.onRemoveImages.bind(this)
    this.onRemoveImageSuccess = this.onRemoveImageSuccess.bind(this)
    this.openEmptyModal = this.openEmptyModal.bind(this)
    this.clearImages = this.clearImages.bind(this)
    this.onCheckboxChange = this.onCheckboxChange.bind(this)
    this.onChangeMainImage = this.onChangeMainImage.bind(this)
  }

  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName('js-competition-static')[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  onDrop(files) {
    this.openModal(files, true)
  }

  openModal(files, skip=false) {
    if (this.state.images.length + files.length > 5) {
      App.events.publish('app:notification:flash:error', 'You cannot attach more than 5 files')
    } else {
      this.handleFileUpload(files, skip)
    }
    this.setState({ modalIsOpen: true })
  }

  openEmptyModal() {
    this.setState({ modalIsOpen: true })
  }

  handleFileUpload(files, skip) {
    let currentFiles = [];

    if (skip === true) {
      currentFiles = files
    } else {
      files.forEach((file) => {
        if (this.state.images.hasOwnProperty(file.name)) {
          // Tech debt [Mediator]
          App.events.publish(
            'app:notification:flash:error',
            'You cannot attach file with the same filename'
          )
          return;
        }

        currentFiles.push(file)
      })
    }

    currentFiles.forEach((file) => {
      const data = new FormData()
      data.append('file', file)

      this.setState(prevState => ({
        preloaders: prevState.preloaders.concat(true),
      }))

      axios.post('/api/internal/competition-images', data)
        .then(this.onUploadSuccess)
        .catch(this.onUploadFailure)
    })
  }

  onUploadSuccess(response) {
    this.setState({
      images: update(this.state.images, { $push: [response.data.image] }),
      preloaders: this.state.preloaders.slice(0, -1),
    })
  }

  onUploadFailure(xhr) {
    this.setState({
      preloaders: this.state.preloaders.slice(0, -1),
    })

    // Tech debt [Mediator]
    App.events.publish('app:notification:flash:error', xhr.response.data.errors[0])
  }

  onChangeMainImage() {
    const image = this.state.selectedImages[0]

    axios.patch(`/api/internal/competition-images/${image.id}`)
      .then(this.onChangeMainImageSuccess(image.id))
      .catch((error) => {})
  }

  onChangeMainImageSuccess(mainImageId) {
    this.setState({
      mainImageId,
      selectedImages: [],
    })

    App.events.publish('app:thumbnail:unselect')
  }

  onRemoveImages() {
    this.state.selectedImages.forEach((image) => {
      axios.delete(`/api/internal/competition-images/${image.id}`)
        .then(this.onRemoveImageSuccess(image))
        .catch((error) => {})
    })
  }

  onRemoveImageSuccess(removableImage) {
    this.setState(prevState => ({
      images: prevState.images.filter(image => image !== removableImage),
      selectedImages: prevState.selectedImages.filter(image => image !== removableImage),
      mainImageId: prevState.mainImageId === removableImage.id ? null : prevState.mainImageId,
    }))
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  clearImages() {
    this.setState({
      images: [],
    })
  }

  onCheckboxChange(image, selected) {
    if (selected) {
      this.setState({
        selectedImages: update(this.state.selectedImages, { $push: [image] }),
      })
    } else {
      this.setState({
        selectedImages: this.state.selectedImages.filter(img => img !== image),
      })
    }
  }

  render() {
    return (
      <div className={`competition-page ${this.props.competition}`}>
        <CompetitionHeader
          competitionSlug={this.props.competition}
        />
        <Router>
          <div>
            <NavigationMenu competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />
            <Routes>
              <Route
                path={`/${this.props.competition}`}
                element={<LandingPage competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />}
              />
              <Route
                path={`/${this.props.competition}/rules`}
                element={<RulesPage competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />}
              />
              <Route
                path={`/${this.props.competition}/categories-and-prizes`}
                element={
                  <CategoriesPage competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />
                }
              />
              <Route
                path={`/${this.props.competition}/partners`}
                element={<PartnersPage competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />}
              />
              <Route
                path={`/${this.props.competition}/judges`}
                element={<JudgesPage competitionSlug={this.props.competition} openEmptyModal={this.openEmptyModal} />}
              />
              <Route
                path={`/${this.props.competition}/gallery`}
                element={
                  <GalleryPage
                    competitionSlug={this.props.competition}
                    galleryOrder={this.state.galleryOrder}
                    gallerySlugs={this.state.gallerySlugs}
                    openEmptyModal={this.openEmptyModal}
                  />
                }
              />
              <Route
                path={`/${this.props.competition}/gallery/:id/:slug`}
                element={
                  <ModalPreview
                    competitionSlug={this.props.competition}
                    galleryOrder={this.state.galleryOrder}
                    gallerySlugs={this.state.gallerySlugs}
                  />
                }
              />
            </Routes>
          </div>
        </Router>
      </div>
    )
  }
}

Competition.propTypes = {
  competition: PropTypes.string.isRequired,
}

export default Competition
